module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetLow.b81b182.jpg";